import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeUpdateCard from "./StripeUpdateCard";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeController = ({
  onSubmit,
  data,
  clearEditor,
  getPayloadFunction,
  hideSaveBtn,
}) => {
  return (
    <Elements stripe={stripePromise}>
      <StripeUpdateCard
        data={data}
        clearEditor={clearEditor}
        onSubmit={onSubmit}
        getPayloadFunction={getPayloadFunction}
        hideSaveBtn={hideSaveBtn}
      />
    </Elements>
  );
};
export default StripeController;
